var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteShiel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5L8 12.5L12.5 7.99999M17 11C17 15.9084 11.646 19.4784 9.69799 20.6149C9.4766 20.744 9.3659 20.8086 9.20968 20.8421C9.08844 20.8681 8.91156 20.8681 8.79032 20.8421C8.6341 20.8086 8.5234 20.744 8.30201 20.6149C6.35396 19.4784 1 15.9084 1 11V6.21759C1 5.41808 1 5.01833 1.13076 4.6747C1.24627 4.37113 1.43398 4.10027 1.67766 3.88552C1.9535 3.64243 2.3278 3.50207 3.0764 3.22134L8.4382 1.21067C8.6461 1.13271 8.75005 1.09373 8.85698 1.07827C8.95184 1.06457 9.04816 1.06457 9.14302 1.07827C9.24995 1.09373 9.3539 1.13271 9.5618 1.21067L14.9236 3.22134C15.6722 3.50207 16.0465 3.64243 16.3223 3.88552C16.566 4.10027 16.7537 4.37113 16.8692 4.6747C17 5.01833 17 5.41808 17 6.21759V11Z",
    stroke: "#F3F3F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShiel);
export default __webpack_public_path__ + "static/media/white_shiel.46b754b4fb8ef1bd3cbf07853a5069f6.svg";
export { ForwardRef as ReactComponent };